//import './index.less';


import { Collapse, Divider, Drawer,  Progress, Row, } from 'antd';
import * as React from 'react';
import { L } from '../../../lib/abpUtility';
 
export interface ITimeClockProps {
    onCancel: () => void;
    visible: boolean;
    secondaryColor: string;
    primaryColor: string;
}

export interface ITimeClockState {

}

export class TimeClock extends React.Component<ITimeClockProps, ITimeClockState> {

    state = {

    };

    render() {

        const { Panel } = Collapse;
        const {
            visible,
            onCancel,

        } = this.props;

        return (
            <Drawer  width={window.innerWidth < 650 ? (window.innerWidth * 0.85) : 420} placement="right" onClose={onCancel} closeIcon={false} closable={window.innerWidth < 650 === true ? true : false} open={visible} >
               <Divider className="font-face-gm" type="horizontal" style={{ fontSize: window.innerWidth < 650=== true ? '2em' : '2.3em', marginBottom: '0px' }} >
                    {L('Time Clock')}
                </Divider>

                <Row style={{ }}>
                    <Progress
                        strokeColor={{
                            from: this.props.secondaryColor,
                            to: this.props.primaryColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                    />
                </Row>


                <Collapse accordion={true}
                    bordered={true}
                    defaultActiveKey={'1'}
                    style={{
                        fontSize: '1.5em',
                        backgroundColor: 'transparent',
                        marginBottom: '0px',
                        marginTop: '5px',
                        border: 'none',
                        boxShadow: 'none'
                    }}
                //onChange={callback}
                //expandIconPosition={expandIconPosition}
                >
                    <Panel header={L('Today')} className="font-face-gm" key="1" extra={''}>
                        <div>

                        </div>
                    </Panel>
                    <Panel header={L('This Period')} className="font-face-gm" key="2" extra={''}>
                        <div>

                        </div>
                    </Panel>
                    <Panel header={L('All Records')} className="font-face-gm" key="3" extra={''}>
                        <div>

                        </div>
                    </Panel>
                </Collapse>


            </Drawer>
        );
    }
}

export default TimeClock;
